import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { TreeSelectorComponent } from "@components/tree-selector/tree-selector.component";
import { chain } from "lodash";
import { SelectionItem } from "~app/common/components/tree-selector/selection-item";
import { Anskaffningsformer, VirkeskopAffarsformer } from "~app/common/models/constants";
import { ITplArbetsorder } from "../../../models/dtos";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { ITplArbetsorderFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-affarsform-filter",
    templateUrl: "./tpl-affarsform-filter.component.html",
    styleUrls: ["./tpl-affarsform-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        TreeSelectorComponent
    ]
})
export class TplAffarsformFilterComponent extends FilterBaseComponent implements OnInit, ITplArbetsorderFilter {
    @Input() dataSource: ITplArbetsorder[];

    selectableAffarsformer: SelectionItem[] = [];

    constructor() {
        super("affarsform");
    }

    match(item: ITplArbetsorder): boolean {
        const selectedAffarsformer = this.selectableAffarsformer
            .filter(si => si.selected)
            .map(si => si.id);

        // eslint-disable-next-line sonarjs/prefer-single-boolean-return
        if (selectedAffarsformer.includes(item.affarsform)) {
            return true;
        }

        return false;
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormControl([]));
        this.initOptions();
    }

    isActive(): boolean {
        return this.value()?.length > 0;
    }

    virkeskopFilterSelected(): boolean {
        const anskaffningsformFilter = this.filterContext?.arbetsorderFilters?.find(x => x.name === "anskaffningsform");
        return anskaffningsformFilter?.isActive() ? anskaffningsformFilter.value().some(x => Anskaffningsformer.isVirkesKop(x)) : false;
    }

    setAnskaffningsformFromSelector(): void {
        this.filterLength = this.getSelectedValues().length;
    }

    value(): string[] {
        return this.getSelectedValues().map(si => si.id);
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        filterContext.addArbetsorderFilter(this.name, this);
    }

    protected onFilterInit(state: string[]): void {
        this.control.setValue(state ?? []);
    }

    protected onFormChange(value: string[]): void {
        this.getSelectedValues().forEach(si => si.selected = false);
        this.filterLength = 0;
    }

    private getSelectedValues(): SelectionItem[] {
        return this.selectableAffarsformer.filter(si => si.selected);
    }

    private initOptions(): void {
        const groupedAoAffarsform = chain(this.dataSource)
            .groupBy(ao => ao.affarsform)
            .value();

        this.selectableAffarsformer = VirkeskopAffarsformer.AllaWithShortType.map(form => (
            {
                text: `${form.key} ${form.value} (${groupedAoAffarsform[form.value]?.length ?? 0})`,
                value: form.value,
                id: form.value
            }));
    }

}
